import { Flex } from "@chakra-ui/react";
import time from "src/utils/time";
import useAnimationFrameUpdater from "src/hooks/useAnimationFrameUpdater";
import { Caption } from "src/atoms/typography";
import SvgContainer from "src/components/SvgContainer";

import { ReactComponent as LoopIcon } from "src/modules/lullaby/icons/loop.svg";

export default function LullabyPlayerCurrentTime({ lullabyPlayer, lullaby }) {
  useAnimationFrameUpdater({ updateRate: 2 });
  const { getCurrentTime, timerSettings } = lullabyPlayer;
  const looped = !timerSettings.enabled && lullaby.looped;
  let formatedDuration;

  if (!looped) {
    const duration = timerSettings.enabled
      ? timerSettings.duration
      : lullaby.duration;
    formatedDuration = time
      .duration(duration)
      .format("h:mm:ss", { stopTrim: "m" });
  }

  return (
    <Flex alignItems="center">
      <Caption color="mediumEmphasis">
        {time.duration(getCurrentTime()).format("h:mm:ss", { stopTrim: "s" })} /
        {!looped && " " + formatedDuration}
      </Caption>
      {looped && (
        <SvgContainer
          ml="4px"
          icon={LoopIcon}
          fill="mediumEmphasis"
          size="16px"
        />
      )}
    </Flex>
  );
}
